<template>
<div class="container-fluid" >

 <div class="card border-success">

  
    <h4 class="card-header text-white bg-primary">
        
    <i class="far fa-clock mr-2" aria-hidden="true"></i>
    VENDITE FASCIA ORARIA</h4>
  

 <div  class="card-body"> 
  
   <div class="row">
   <div class="col"> 

  <div class="card border-info" >
  <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-black">


  <form name="filter" v-on:submit.prevent="submit()">

    <label for="date_doc"><strong>DA DATA VENDITA </strong></label>
    <input :disabled="items.length>0" required v-model="data1" type="date" class="form-control" placeholder="" >        
    
    <label for="date_doc"><strong>A DATA VENDITA</strong></label>
    <input :disabled="items.length>0" required v-model="data2" type="date" class="form-control" placeholder="" >        
    <store-select v-bind:props="store"  @update="setStoreId"></store-select>   
    
    
   
   

<div class="card-footer bg-transparent border-info">
   <button type="submit"  class="btn btn-primary float-right">
    <i class="far fa-play-circle mr-2"></i>
    ESEGUI
      <span v-if="spinner" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
     </button>           

    <button @click="items=[]" type="button"   class="btn btn-outline-secondary ">
       <i class="fas fa-redo-alt mr-2"></i>
      
        RESET
    </button>   
</div>
  </form>
</div>
</div>
</div>

<!--COL 2 -->
<div class="col-md-10">
 <alert-box style="margin-top:10px" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>


 <div class="table-responsive">    
 <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table id='my-table' class="table table table-sm table-hover table-bordered table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col">Giorno</th>
        
        <th scope="col">09:00 </th>
        <th scope="col">10:00 </th>
        <th scope="col">11:00 </th>
        <th scope="col">12:00 </th>
        <th scope="col">13:00 </th>
        <th scope="col">14:00</th>
        <th scope="col">15:00</th>
        <th scope="col">16:00</th>
        <th scope="col">17:00</th>
        <th scope="col">18:00</th>
        <th scope="col">19:00</th>
        <th scope="col">20:00</th>
        <th scope="col">21:00</th>
        <th scope="col">22:00</th>
        <th scope="col">23:00</th>
        

        
        <th class="text-right" scope="col">Totale (€)</th>
                
        
        
           
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in items" :key="index">
      
                
        <td >{{item.giorno}}</td> 

        <td >{{fmt1(item.t09)}}</td>    
        <td >{{fmt1(item.t10)}}</td>    
        <td >{{fmt1(item.t11)}}</td>    
        <td >{{fmt1(item.t12)}}</td>    
        <td >{{fmt1(item.t13)}}</td>
        <td >{{fmt1(item.t14)}}</td>        
        <td >{{fmt1(item.t15)}}</td>    
        <td >{{fmt1(item.t16)}}</td>    
        <td >{{fmt1(item.t17)}}</td>    
        <td >{{fmt1(item.t18)}}</td>    
        <td >{{fmt1(item.t19)}}</td>    
        <td >{{fmt1(item.t20)}}</td>
        <td >{{fmt1(item.t21)}}</td>    
        <td >{{fmt1(item.t22)}}</td>
        <td >{{fmt1(item.t23)}}</td>
        
        
        <td class="text-right"><strong>{{fmt1(item.total)}}</strong></td>
        
       
      </tr> 
    </tbody>

   <tfoot>
    <tr >
      
                
      <td ></td> 

      <td >{{fmt1(total.total09)}}</td>    
      <td >{{fmt1(total.total10)}}</td>    
      <td >{{fmt1(total.total11)}}</td>    
      <td >{{fmt1(total.total12)}}</td>    
      <td >{{fmt1(total.total13)}}</td>
      <td >{{fmt1(total.total14)}}</td>        
      <td >{{fmt1(total.total15)}}</td>    
      <td >{{fmt1(total.total16)}}</td>    
      <td >{{fmt1(total.total17)}}</td>    
      <td >{{fmt1(total.total18)}}</td>    
      <td >{{fmt1(total.total19)}}</td>    
      <td >{{fmt1(total.total20)}}</td>   
      <td >{{fmt1(total.total21)}}</td>    
      <td >{{fmt1(total.total22)}}</td>   
      <td >{{fmt1(total.total23)}}</td>   
      <td></td>
     <!-- <td class="text-right"><strong>{{fmt1(item.grandTotal)}}</strong></td>-->
      
     
    </tr> 
   </tfoot>
    
  </table>

</div>
 </div> 
</div>  

</div>
 </div>
 </div>


<button :disabled="items.length==0 || spinner_pdf == true" @click="pdf()" type="button"   class="btn btn-success mt-2 mb-3 float-right mr-2">

<i class="fas fa-file-export mr-2"></i>
      ESPORTA PDF
      <span v-if="spinner_pdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>  


</div>


</template>
<script>
import api             from "@/api";
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';

import storeSelect       from '@/components/common/StoreSelect_1.vue'
import jsPDF             from 'jspdf';
import fmt               from '@/components/mixins/fmt.js'

//import 'jspdf-autotable'
//import autoTable from 'jspdf-autotable'

export default {
  mixins:[fmt],
  components: {alertBox,storeSelect},
  data() {
    return {
      
    store             : 
    {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true
      },  


      
      
      
      
      

      data1           : null,
      data2           : new Date().toISOString().slice(0,10),
      
      alert           : false, 
      spinner         : false,
      spinner_pdf     : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      title           : {}
     
      
      
    }
  },

  computed :{
    ...mapGetters(['company']),
    total: function()
    {
      let total = {total09:0,total10:0,total11:0,total12:0,total13:0,total14:0,total15:0,total16:0,total17:0,total18:0,total19:0,total20:0,total21:0,total22:0,total23:0}
      this.items.forEach(item => {
        
        
        total.total09 = total.total09 + item.t09
        total.total10 = total.total10 + item.t10
        total.total11 = total.total11 + item.t11
        total.total12 = total.total12 + item.t12
        total.total13 = total.total13 + item.t13
        total.total14 = total.total14 + item.t14
        total.total15 = total.total15 + item.t15
        total.total16 = total.total16 + item.t16
        total.total17 = total.total17 + item.t17
        total.total18 = total.total18 + item.t18
        total.total19 = total.total19 + item.t19
        total.total20 = total.total20 + item.t20
        total.total21 = total.total21 + item.t21
        total.total22 = total.total22 + item.t22
        total.total23 = total.total23 + item.t23
        
        

      })
      return total
    },
  
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

    //this.getGrouping()
  },
  methods: {


   header_pdf()
   {
      
     
    


   }, 

   async  pdf()
    {

      
      const addFooters = doc => {
      const pageCount = doc.internal.getNumberOfPages()
      doc.setFont('helvetica', 'italic')
      doc.setFontSize(8)
      for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i)

        doc.text('Pag. ' + String(i) + ' di ' + String(pageCount), 50,200, {
        align: 'center'})
      }
      }
       
       this.spinner_pdf = true


       const doc = new jsPDF(
         
         {
         
       orientation: "landscape",

        
      })
      doc.setFontSize(8)
      
      doc.text("VENDITE SU FASCIA ORARIA " + this.title.store +  " dal  " +  this.data1 + ' al ' + this.data2 ,15,10)
      
      
      doc.autoTable(
      
    
       { html: '#my-table',
       margin       : {top:20},
       showFoot: 'lastPage',
       footStyles:{fontStyle:'bold',fillColor:'white',textColor:'black',fontSize:7,cellWidth: 'wrap',},

          /*  
          didParseCell: function(data) {
            if (data.row.cells[0].text == 'Totale') {
              
              
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.fontSize = 6
              //console.log(data.row.cells[0].text)

            }
          


          
          }, 
                */


       styles : {
          font       : 'helvetica',
          //rowHeight  : 5,  
          fontSize   : 6,
          }
        })
      
     
     addFooters(doc) 
    //var string = doc.output('datauristring');
    //doc.output('dataurlnewwindow');
    var fileName = 'Report'
    window.open(doc.output('bloburl', { filename: fileName }), '_blank');
    //console.log(string)
    this.spinner_pdf = false
    //doc.save('sellOut_' + Date.now()  + '.pdf', {returnPromise:true}).then(this.spinner_pdf=false);
      
     
    },
   
    setStoreId(storeId,e)
    {
      this.storeId = storeId
      this.title.store = e.target.options[e.target.options.selectedIndex].text

      
    },  
    
    submit() 
    {
     this.getData()
    },  
    
  
    async getData() {
      
      this.row_total = []
      this.items = []
      
      
      
      this.msg.title = ''
      
      var sp = {'sp' : 'spSoldTimeTable'} 
      var data  = {

          'companyId':this.company.Id,'data1':this.data1,'data2':this.data2,'storeId':this.storeId
          
      }
      
      var json  = Object.assign(data, sp)
      this.spinner = true


      await api.post(json).then(res => {
         
          if(res.status==200)
            {
             
              this.items = res.data.recordsets[0]
              
                              
            if(this.items.length==0)
              {
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

            

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      


    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 600px;
overflow   : auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   :  hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : darkgreen;
    color        : white;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    

 }

.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
</style>